// U+00AD SOFT HYPHEN stands in for a real hyphen in source passages
// (half\u00adoff, 15\u00ad24). A soft-hyphen run becomes one "-" when it sits
// between two characters that are neither whitespace nor a dash, or when only
// spaces/tabs separate it from a letter or digit on both sides (the spaces go
// too: "fair\u00ad minded" -> "fair-minded"), except a suspended hyphen (no space
// on the left, next word and/or/to) which keeps its space ("25\u00ad to 34" ->
// "25- to 34"). Any other run is deleted. Applied after the other cleanup so
// neighbors are judged on cleaned text. Keep in sync with
// _SOFT_HYPHEN_JOIN_RE in utils/passage_sanitize.py.
const SHY_WORD = '[\\p{L}\\p{N}]';
const SHY_SOLID = '[^\\s\\-\\u2010-\\u2015\\u2212\\ufe58\\ufe63\\uff0d\\u00ad]';
const SHY_SUSPENDED_NEXT = `(?:and|or|to)(?!${SHY_WORD}|\\u00ad)`;
const SOFT_HYPHEN_JOIN = new RegExp(
  `(?<=${SHY_WORD})\\u00ad+(?=[ \\t]+${SHY_SUSPENDED_NEXT})`
  + `|(?<=${SHY_WORD})[ \\t]+\\u00ad+[ \\t]*(?=${SHY_WORD})`
  + `|(?<=${SHY_WORD})\\u00ad+[ \\t]+(?=${SHY_WORD})(?!${SHY_SUSPENDED_NEXT})`
  + `|(?<=${SHY_SOLID})\\u00ad+(?=${SHY_SOLID})`,
  'gu',
);

export function normalizeSoftHyphens(text: string): string {
  if (!text.includes('\u00ad')) return text;
  return text.replace(SOFT_HYPHEN_JOIN, '-').replace(/\u00ad/g, '');
}

/** Plain-text clipboard cleanup. Keep this policy in sync with utils/passage_sanitize.py.
 * Delete nonprinting formatting, but preserve word/line boundaries and visible
 * combining accents/variation selectors. Do not use NFKC on source passages.
 */
export function normalizePassageText(text: string): string {
  return normalizeSoftHyphens(text
    .replace(/[\u00a0\u1680\u2000-\u200b\u202f\u205f\u2800\u3000]/g, ' ')
    .replace(/[\u000b\u000c\u0085\u2028\u2029]/g, '\n')
    .replace(/[\u0000-\u0008\u000e-\u001f\u007f-\u0084\u0086-\u009f\u034f\u061c\u115f\u1160\u17b4\u17b5\u180e\u200c-\u200f\u202a-\u202e\u2060-\u206f\u3164\ufeff\uffa0\ufff9-\ufffb]/g, ''));
}
